<template>
    <view-box>
        <x-header :left-options="{backText: ''}" >{{$t('account.credit.title')}}</x-header>
        <div style="text-align: center; padding-top: 30px; font-size: 20px;">{{$t('account.credit.myCredit')}}</div>
        <div style="text-align: center; font-size: 70px">{{currentUser.credit}}</div>
        <flexbox style="padding: 20px 30px 20px 30px">
            <!-- Redemption is not ready (10 july)
            <flexbox-item>
                <x-button type="primary" style="background-color: #5890DC" is-link @click.native="$router.push('/account/redemption')">積分兌現</x-button>
            </flexbox-item> 
            -->
            <flexbox-item>
                <x-button type="primary" style="background-color: #5890DC" is-link @click.native="$router.push('/account/edit')">{{$t('account.credit.editPaymentMessage')}}</x-button>
            </flexbox-item>
        </flexbox>
        <group :title="$t('account.credit.history')" >
            <div v-for="item in currentTxn.list">
                <!-- <cell v-if="item.type == 'C' " :title="$t('account.credit.credit')" :inline-desc="$t('account.credit.orderNumber')+item.orderNumber"><cell :title="item.amount" :inline-desc="item.createTime"></cell></cell>
                <cell v-if="item.type == 'P' " :title="$t('account.credit.pay')" :inline-desc="$t('account.credit.orderNumber')+item.orderNumber"><cell :title="item.amount" :inline-desc="item.createTime"></cell></cell>
                <cell v-if="item.type == 'B' " :title="$t('account.credit.buy')" :inline-desc="$t('account.credit.orderNumber')+item.orderNumber"><cell :title="item.amount" :inline-desc="item.createTime"></cell></cell>
                <cell v-if="item.type == 'R' " :title="$t('account.credit.commission')" :inline-desc="$t('account.credit.orderNumber')+item.orderNumber"><cell :title="item.amount" :inline-desc="item.createTime"></cell></cell>
                <cell v-if="item.type == 'F' " :title="$t('account.credit.refund')" :inline-desc="$t('account.credit.orderNumber')+item.orderNumber"><cell :title="item.amount" :inline-desc="item.createTime"></cell></cell> -->
                <cell :title="creditTypeMapping(item.type)" :inline-desc="$t('account.credit.orderNumber')+item.orderNumber"><cell :title="item.amount" :inline-desc="item.createTime"></cell></cell>
            </div>
        </group>
        <flexbox v-if="this.count < currentTxn.total" style="padding: 20px 30px 20px 30px">
            <flexbox-item>
                <x-button type="primary" style="background-color: #5890DC;" is-link @click.native="loadMore()">{{$t('product.list.loadMore')}}</x-button>
            </flexbox-item>
        </flexbox>
        <divider v-else style="padding: 20px ">{{$t('account.credit.noMoreData')}}</divider>
    </view-box>
</template>

<script>
import { Flexbox, FlexboxItem, Divider, ViewBox, XButton, Group, Cell, XHeader } from 'vux'
export default {
    name: 'Credit',
    components: {
        Flexbox,
        FlexboxItem,
        Divider,
        ViewBox,
        XButton,
        Group,
        Cell,
        XHeader
    },
    data() {
        return{
            currentUser: {},
            count: 10
        }
    },
    created() {
        this.currentUser = JSON.parse(localStorage.currentUser);
        this.getUserTxn();
    },
    computed: {
        currentTxn() {
            return this.$store.state.currentTxn;
        },
    },
    methods: {
        getUserTxn() {

            this.$store.dispatch('Account/getUserTxn', {
                    ID:this.currentUser.ID,
                    count: this.count
                }).then((json) => {
                    if (json.status == 401) {
                    Cookies.remove('token');
                    this.$router.push('/login');
                    } else {
                    this.$store.commit("setCurrentTxn", json.data);
                    // console.log(json.data);
                }
            }).catch((err) => {
                console.error(err);
            });
        },
        loadMore() {
            this.count += 10;
            this.getUserTxn();
        },
        creditTypeMapping(type) {
            switch(type) {
                case 'C':
                    return this.$t('account.credit.credit');
                    break;
                case 'P':
                    return this.$t('account.credit.pay');
                    break;
                case 'B':
                    return this.$t('account.credit.buy');
                    break;
                case 'R':
                    return this.$t('account.credit.commission');
                    break;
                case 'F':
                    return this.$t('account.credit.refund');
                    break;
            }
        }
    },
}
</script>





// WEBPACK FOOTER //
// src/Account/containers/Credit/Credit.vue